"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBalancesFullDetailList = void 0;
const react_1 = require("react");
const useBalancesFullSectionList_1 = require("./useBalancesFullSectionList");
const Helpers_1 = require("./Helpers");
var LoadingType;
(function (LoadingType) {
    LoadingType[LoadingType["InitLoading"] = 0] = "InitLoading";
    LoadingType[LoadingType["Refreshing"] = 1] = "Refreshing";
})(LoadingType || (LoadingType = {}));
const useBalancesFullDetailList = (local, type, onError, merge_order_group) => {
    const [sectionData, setSectionData] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [refreshing, setRefreshing] = (0, react_1.useState)(false);
    const pageTokenRef = (0, react_1.useRef)();
    const [hasMore, setHasMore] = (0, react_1.useState)(false);
    const resetData = (0, react_1.useCallback)(() => {
        pageTokenRef.current = "";
        setSectionData([]);
        setLoading(false);
        setRefreshing(false);
    }, []);
    const loadMore = (0, react_1.useCallback)(() => {
        var _a;
        if (!pageTokenRef.current || loading || refreshing || !hasMore) {
            return;
        }
        setLoading(true);
        (_a = (0, useBalancesFullSectionList_1.getBalanceParticularGroup)(local, type, pageTokenRef.current, merge_order_group)) === null || _a === void 0 ? void 0 : _a.subscribe((data) => {
            if (!data) {
                return resetData();
            }
            // 处理某一类 section genSectionDataTransformer
            const transformer = (0, Helpers_1.genSectionDataTransformer)(data.prices);
            const { data: formattedData, has_more } = transformer(data.detail);
            setSectionData((prevData) => {
                return [...prevData, ...formattedData];
            });
            setHasMore(has_more);
            pageTokenRef.current = data.next_page_token;
            setLoading(false);
        }, (error) => {
            pageTokenRef.current = "";
            setLoading(false);
            onError(error);
        });
    }, [hasMore, loading, local, merge_order_group, onError, refreshing, resetData, type]);
    const onRefresh = (0, react_1.useCallback)((loadingType) => {
        if (loading || refreshing) {
            return;
        }
        const changeLoadingState = loadingType === LoadingType.InitLoading ? setLoading : setRefreshing;
        changeLoadingState(true);
        (0, useBalancesFullSectionList_1.getBalanceParticularGroup)(local, type, undefined, merge_order_group).subscribe({
            next: (data) => {
                if (!data) {
                    return resetData();
                }
                const transformer = (0, Helpers_1.genSectionDataTransformer)(data.prices);
                const { data: formattedData, has_more } = transformer(data.detail);
                setSectionData(formattedData);
                changeLoadingState(false);
                setHasMore(has_more);
                pageTokenRef.current = data.next_page_token;
            },
            error: (error) => {
                pageTokenRef.current = "";
                changeLoadingState(false);
                onError(error);
            },
        });
    }, [loading, refreshing, local, type, merge_order_group, resetData, onError]);
    /**
     * 第一次进入页面，加载数据
     */
    (0, react_1.useEffect)(() => {
        onRefresh(LoadingType.InitLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [local]);
    return {
        hasMore,
        sectionData,
        loadMore,
        loading,
        refreshing,
        onRefresh,
    };
};
exports.useBalancesFullDetailList = useBalancesFullDetailList;
